import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ChangePassword } from "./PasswordChangeAPI";

// Async thunk to confirm password reset
export const ChangePasswordAsync = createAsyncThunk(
  "password/change",
  async ({ current_password, password, password_confirmation }, { rejectWithValue }) => {
    try {
      return await ChangePassword({ current_password, password, password_confirmation });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const passwordSlice = createSlice({
  name: "changePassword",
  initialState: {
    loading: false,
    success: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ChangePasswordAsync.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(ChangePasswordAsync.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(ChangePasswordAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default passwordSlice.reducer;
